// import React, { useEffect } from 'react';
// // import { useFileContext } from '../../../../Contexts/FileContext';
// // import ssoImg1 from "./../../../../assets/images/checklists-form-img.png";
// import pdfIcon from "./../../assets/images/pdf.png";
// import ssoImg1 from "./../../assets/images/checklists-form-img.png";
// import { WebApiURL } from './../../Constants/Constants';
// // import { useFileContext } from './../../Constants/FileContext';
// import { useFileContext } from './../../Contexts/FileContext';
// import { FaFilePdf } from "react-icons/fa";



// function AwardedTenders() {
//     const {
//         setComponentName,
//         documents,
//         loading,
//         setSection
//     } = useFileContext();

//     useEffect(() => {
//         setComponentName("ALL FORMS");
//         setSection("");
//     }, [setComponentName]);
//     const tableStyle = {
//         width: "100%",
//         borderCollapse: "collapse",
//         fontFamily: "Arial, sans-serif",
//     };

//     const thStyle = {
//         backgroundColor: "#008B8B", // Teal header
//         color: "white",
//         padding: "10px",
//         textAlign: "left",
//         fontWeight: "bold",
//         border: "1px solid #ccc",
//     };

//     const tdStyle = {
//         padding: "10px",
//         border: "1px solid #ccc",
//     };

//     const rowEven = { backgroundColor: "#F9F9F9" };

//     const groupedDocs = documents.reduce((acc, doc) => {
//         const folder = doc.folderName || 'Uncategorized';
//         if (!acc[folder]) acc[folder] = [];
//         acc[folder].push(doc);
//         return acc;
//     }, {});

//     return (
//         <>
//             <div className="service-title font-700 mb-3 text-uppercase">
//                 Awarded
//                 <span className="text-orange-ef3e33 font-400"> Tenders </span>
//             </div>

//             <div className="row g-3 g-sm-4 g-md-4">
//                 <div className="col-12">
//                     <div className="accordion blackTab" id="blackTab">

//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTabN2"
//                                     aria-expanded="false"
//                                     aria-controls="blackTabN2"
//                                 >SAMSA/085/2023/24 – APPOINTMENT OF A PANEL OF LEGAL SERVICES PROVIDERS
//                                      </button>
//                             </h2>
//                             <div
//                                 id="blackTabN2"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             >
//                                 <div style={{ padding: "2px" }}>
//                                     {/* First Table */}
//                                     <table style={tableStyle}>
//                                         <tbody>
//                                             <tr>
//                                                 <th style={thStyle} colSpan={1}>
//                                                     NAME OF INSTITUTION
//                                                 </th>
//                                                 <td style={tdStyle}>
//                                                     SOUTH AFRICAN MARITIME SAFETY AUTHORITY(SAMSA)
//                                                 </td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                 <td style={tdStyle}>
//                                                     SAMSA/085/2023/24 – APPOINTMENT OF A PANEL OF LEGAL SERVICES PROVIDERS FOR THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY

//                                                     </td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>CONTRACT NUMBER</th>
//                                                 <td style={tdStyle}>SAMSA/085/2023/24  ​</td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>CONTRACT PERIOD</th>
//                                                 <td style={tdStyle}>FIVE (5) YEARS ​</td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>DATE OF AWARD</th>
//                                                 <td style={tdStyle}>19/09/2025</td>
//                                             </tr>
//                                         </tbody>
//                                     </table>

//                                     <br />

//                                     {/* Second Table */}
//                                     <table style={tableStyle}>
//                                         <thead>
//                                             <tr>
//                                                 <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                 <th style={thStyle}>BBBEE LEVEL</th>
//                                                 <th style={thStyle}>NAME OF DIRECTOR</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             <tr>
//                                                 <td style={tdStyle}>Various (Panel)</td>
//                                                 <td style={tdStyle}>N/A</td>
//                                                 <td style={tdStyle}>N/A</td>
//                                             </tr>
//                                              <tr style={rowEven}>
//                                                     <td style={tdStyle} colSpan={3}><a href="https://www.samsa.org.za/api/api/File/view/901" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                                                                           <FaFilePdf style={{ marginRight: "5px" }} />Annexure A - Legal Tender_ Areas of Practices.pdf
//                                                                         </a></td>
//                                                     {/* <td style={tdStyle}>R 13 627 051.61</td>
//                                                     <td style={tdStyle}></td> */}
//                                                 </tr>

//                                         </tbody>
//                                     </table>

//                                 </div>

//                             </div>
//                         </div>

//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTabN1"
//                                     aria-expanded="false"
//                                     aria-controls="blackTabN1"
//                                 >
//                                     SAMSA/101/2024/25 – THE APPOINTMENT OF AN ACCREDITED SERVICE PROVIDER
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTabN1"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             >
//                                 <div style={{ padding: "2px" }}>
//                                     {/* First Table */}
//                                     <table style={tableStyle}>
//                                         <tbody>
//                                             <tr>
//                                                 <th style={thStyle} colSpan={1}>
//                                                     NAME OF INSTITUTION
//                                                 </th>
//                                                 <td style={tdStyle}>
//                                                     SOUTH AFRICAN MARITIME SAFETY AUTHORITY(SAMSA)
//                                                 </td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                 <td style={tdStyle}>
//                                                     SAMSA/101/2024/25 – THE APPOINTMENT OF AN ACCREDITED SERVICE PROVIDER FOR THE IMPLEMENTATION OF SAGE INTACCT FOR AUTOMATION OF FINANCE AND SUPPLY CHAIN MANAGEMENT (SCM) PROCESSES INCLUDING SUPPORT AND MAINTENANCE SERVICES, WHICH SHOULD INCLUDE TRANSACTION PROCESSING, REPORTING, FORECASTING, BUDGETING AND SUPPLY CHAIN MANAGEMENT CAPABILITIES FOR THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) FOR A PERIOD OF FIVE (5) YEARS, WITH THE OPTION OF A TWO YEARS EXTENSION BASED ON PERFORMANCE
//                                                 </td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>CONTRACT NUMBER</th>
//                                                 <td style={tdStyle}>SAMSA/101/2024/25  ​</td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>CONTRACT PERIOD</th>
//                                                 <td style={tdStyle}>FIVE (5) YEARS ​</td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>DATE OF AWARD</th>
//                                                 <td style={tdStyle}>16/09/2025</td>
//                                             </tr>
//                                         </tbody>
//                                     </table>

//                                     <br />

//                                     {/* Second Table */}
//                                     <table style={tableStyle}>
//                                         <thead>
//                                             <tr>
//                                                 <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                 <th style={thStyle}>BBBEE LEVEL</th>
//                                                 <th style={thStyle}>NAME OF DIRECTOR</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             <tr>
//                                                 <td style={tdStyle}>OS Holdings (Pty) Ltd</td>
//                                                 <td style={tdStyle}>BBBEE Level 1</td>
//                                                 <td style={tdStyle}>Nomsa Olivia Nteleko<br />Amanda Promise Nteleko<br />Rorisang Zachora Pule</td>
//                                             </tr>
//                                              <tr style={rowEven}>
//                                                     <td style={tdStyle}>CONTRACT AMOUNT</td>
//                                                     <td style={tdStyle}>R 13 627 051.61</td>
//                                                     <td style={tdStyle}></td>
//                                                 </tr>

//                                         </tbody>
//                                     </table>

//                                 </div>

//                             </div>
//                         </div>





//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab1"
//                                     aria-expanded="true"
//                                     aria-controls="blackTab1"
//                                 >
//                                     SAMSA-103-2024-25-APPOINTMENT OF A PANEL OF SERVICE PROVIDERS TO PROVIDE SPECIALISED
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTab1"
//                                 className="accordion-collapse collapse show"
//                                 data-bs-parent="#blackTab"
//                             >
//                                 <div className="accordion-body">
//                                     <div className="row g-3">
//                                         <div className="col-md-12">
//                                             <div style={{ padding: "2px" }}>
//                                                 {/* First Table */}
//                                                 <table style={tableStyle}>
//                                                     <tbody>
//                                                         <tr>
//                                                             <th style={thStyle} colSpan={1}>
//                                                                 NAME OF INSTITUTION
//                                                             </th>
//                                                             <td style={tdStyle}>
//                                                                 SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                             <td style={tdStyle}>
//                                                                 THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS TO PROVIDE
//                                                                 SPECIALISED PRINTING SERVICES RELATED TO MARITIME STATUTORY
//                                                                 DOCUMENTATION (NATIONALLY) FOR SAMSA FOR THREE YEARS
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <th style={thStyle}>CONTRACT NUMBER</th>
//                                                             <td style={tdStyle}>SAMSA/103/2024/25</td>
//                                                         </tr>
//                                                         <tr>
//                                                             <th style={thStyle}>CONTRACT PERIOD</th>
//                                                             <td style={tdStyle}>THREE YEARS</td>
//                                                         </tr>
//                                                         <tr>
//                                                             <th style={thStyle}>DATE OF AWARD</th>
//                                                             <td style={tdStyle}>27/05/2025</td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </table>

//                                                 <br />

//                                                 {/* Second Table */}
//                                                 <table style={tableStyle}>
//                                                     <thead>
//                                                         <tr>
//                                                             <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                             <th style={thStyle}>BBBEE LEVEL</th>
//                                                             <th style={thStyle}>NAME OF DIRECTOR</th>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         <tr>
//                                                             <td style={tdStyle}>Nyalu Communications CC</td>
//                                                             <td style={tdStyle}>BBBEE Level 1</td>
//                                                             <td style={tdStyle}>Ephraim Mashisani</td>
//                                                         </tr>
//                                                         <tr style={rowEven}>
//                                                             <td style={tdStyle}>Blue Storm 9 T/A Production X (Pty) Ltd</td>
//                                                             <td style={tdStyle}>BBBEE Level 1</td>
//                                                             <td style={tdStyle}>Nahshon Anton Naidoo</td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle}>Renform Corporate Print Media CC</td>
//                                                             <td style={tdStyle}>BBBEE Level 1</td>
//                                                             <td style={tdStyle}>Thomas Michel Du Sart</td>
//                                                         </tr>
//                                                         <tr style={rowEven}>
//                                                             <td style={tdStyle}>Spot the Print CC</td>
//                                                             <td style={tdStyle}>BBBEE Level 1</td>
//                                                             <td style={tdStyle}>
//                                                                 <div>Kopano Brian Ngobeni</div>
//                                                                 <div>Kenuel Ntiyiso Ngobeni</div>
//                                                             </td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </table>
//                                                 <table style={tableStyle}>
//                                                     <tbody>
//                                                         <tr>
//                                                             <th style={thStyle} colSpan={6}>
//                                                                 INVITATION TO BID
//                                                             </th>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle}><strong>BID NUMBER</strong></td>
//                                                             <td style={tdStyle} colSpan={2}><strong>CLOSING DATE</strong></td>
//                                                             <td style={tdStyle} colSpan={2}><strong>DESCRIPTION</strong></td>
//                                                             <td style={tdStyle}><strong>LOCATION OF THE SAMSA HEAD OFFICE</strong></td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle}>SAMSA/103/2024/25</td>
//                                                             <td style={tdStyle} colSpan={2}>
//                                                                 21/11/2024<br />11H00 a.m.
//                                                             </td>
//                                                             <td style={tdStyle} colSpan={2}>
//                                                                 <strong>
//                                                                     APPOINTMENT OF A PANEL OF SERVICE PROVIDERS TO PROVIDE SPECIALISED PRINTING
//                                                                     SERVICE RELATED TO MARITIME STATUTORY DOCUMENTATION (NATIONALLY) FOR SOUTH
//                                                                     AFRICAN MARITIME SAFETY AUTHORITY FOR THE PERIOD OF THREE (3) YEARS
//                                                                 </strong>
//                                                             </td>
//                                                             <td style={tdStyle}>
//                                                                 146 Lunnon Road<br />
//                                                                 Cnr Jan Shoba & Lunnon Road<br />
//                                                                 <strong>HILLCREST</strong><br />
//                                                                 PRETORIA<br />0183
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle} colSpan={3}><strong>Compulsory Site Inspection</strong></td>
//                                                             <td style={tdStyle} colSpan={3}><strong>Date: 06/11/2024</strong></td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle} colSpan={3}>Venue</td>
//                                                             <td style={tdStyle} colSpan={3}>
//                                                                 146 Lunnon Road<br />
//                                                                 Cnr Jan Shoba & Lunnon Road<br />
//                                                                 <strong>HILLCREST</strong><br />
//                                                                 PRETORIA<br />0183
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle} colSpan={3}>Time</td>
//                                                             <td style={tdStyle} colSpan={3}><strong>10:00</strong></td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle} colSpan={6}>
//                                                                 For general enquiries, please contact Mr Ivor Mothoane at imothoane@samsa.org.za. Only written enquiries will be responded to.
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle} colSpan={2}>Ivor Mothoane</td>
//                                                             <td style={tdStyle}>Tel</td>
//                                                             <td style={tdStyle} colSpan={3}>012 366 2600</td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle} colSpan={2}></td>
//                                                             <td style={tdStyle}>Email</td>
//                                                             <td style={tdStyle} colSpan={3}>imothoane@samsa.org.za</td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle} colSpan={6}>
//                                                                 Tender documents can be downloaded on SAMSA website <a href="https://www.samsa.org.za">www.samsa.org.za</a> or on the National Treasury e-Tender portal.<br />
//                                                                 <a href="/Tender%20Documents/Bid%20Document%20Printing%20(Operations)%202024.pdf">
//                                                                     📄 Bid Document Printing (Operations) 2024.pdf
//                                                                 </a><br />
//                                                                 <a href="/Tender%20Documents/2.%20TENDER%20REGISTER.pdf">📄 2. TENDER REGISTER.pdf</a>
//                                                                 <ul>
//                                                                     <li>Number of ORIGINAL bid documents for contract signing: TWO</li>
//                                                                     <li>Electronic Copy of the original document in PDF (flash drive): ONE</li>
//                                                                 </ul>
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td style={tdStyle} colSpan={6}>
//                                                                 SAMSA reserves the right to amend any date specified above. Any changes will be communicated via SAMSA website or the National Treasury e-Tender portal.<br />
//                                                                 SAMSA reserves the right to accept or reject any submission in full or in part, and to suspend this process and reject all proposals or part thereof, at any time prior to the awarding of the contract.
//                                                             </td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </table>
//                                             </div>

//                                         </div>

//                                     </div>

//                                 </div>
//                             </div>
//                         </div>

//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab2"
//                                     aria-expanded="false"
//                                     aria-controls="blackTab2"
//                                 >
//                                     THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY: MARITIME SPECIAL PROJECTS</button>
//                             </h2>
//                             <div
//                                 id="blackTab2"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             >
//                                 <div className="accordion-body">
//                                     <div style={{ fontFamily: "Arial, sans-serif", padding: "20px", lineHeight: "1.6" }}>

//                                         <div style={{ padding: "2px" }}>
//                                             {/* First Table */}
//                                             <table style={tableStyle}>
//                                                 <tbody>
//                                                     <tr>
//                                                         <th style={thStyle} colSpan={1}>
//                                                             NAME OF INSTITUTION
//                                                         </th>
//                                                         <td style={tdStyle}>
//                                                             SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                         </td>
//                                                     </tr>
//                                                     <tr>
//                                                         <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                         <td style={tdStyle}>
//                                                             APPOINTMEN​T OF A PANEL OF SERVICE PROVIDERS TO SUPPLY VICTUALS (PROVISIONS), NEW BED LINEN, NEW CURTLERY, NEW CROCKERY, AND OTHER CONSUMABLES TO THE SIX VESSELS (AFRICANA, ELLEN KHUZWAYO, SARAH BAARTMAN, LILIAN NGOYI, RUTH FIRST AND VICTORIA MXENGE FOR A PERIOD OF ONE (1) YEAR, TEN (10) MONTHS
//                                                         </td>
//                                                     </tr>
//                                                     <tr>
//                                                         <th style={thStyle}>CONTRACT NUMBER</th>
//                                                         <td style={tdStyle}>SAMSA/100/2024/25​ ​</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <th style={thStyle}>CONTRACT PERIOD</th>
//                                                         <td style={tdStyle}>ONE (1) YEAR, TEN (10) MONTHS ​ ​</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <th style={thStyle}>DATE OF AWARD</th>
//                                                         <td style={tdStyle}>04/07/2025     </td>
//                                                     </tr>
//                                                 </tbody>
//                                             </table>

//                                             <br />

//                                             {/* Second Table */}
//                                             <table style={tableStyle}>
//                                                 <thead>
//                                                     <tr>
//                                                         <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                         <th style={thStyle}>BBBEE LEVEL</th>
//                                                         <th style={thStyle}>NAME OF DIRECTOR</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     <tr>
//                                                         <td style={tdStyle}>Queens Holding and Investments</td>
//                                                         <td style={tdStyle}>BBBEE Level 1</td>
//                                                         <td style={tdStyle}>Xolisa Gcilitsana</td>
//                                                     </tr>
//                                                     <tr style={rowEven}>
//                                                         <td style={tdStyle}>Kwality Brands Africa (Pty) Ltd</td>
//                                                         <td style={tdStyle}>BBBEE Level 1</td>
//                                                         <td style={tdStyle}>Rafiq Aboobaker Ahmed Tayob</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle}>PNN Ship Suppliers and Logistics cc</td>
//                                                         <td style={tdStyle}>BBBEE Level 1</td>
//                                                         <td style={tdStyle}>Armugum Regge Nair, Ingrid Lalita Pillay</td>
//                                                     </tr>
//                                                     <tr style={rowEven}>
//                                                         <td style={tdStyle}>Sues Kitchen (Pty) Ltd</td>
//                                                         <td style={tdStyle}>BBBEE Level 1</td>
//                                                         <td style={tdStyle}>
//                                                             <div>Tsakani Susan Mboweni</div>
//                                                         </td>
//                                                     </tr>
//                                                     <tr style={rowEven}>
//                                                         <td style={tdStyle}>Taroworx (Pty) Ltd</td>
//                                                         <td style={tdStyle}>BBBEE Level 1</td>
//                                                         <td style={tdStyle}>
//                                                             <div>Mutshutshu Terrens Mokono​</div>
//                                                         </td>
//                                                     </tr>
//                                                 </tbody>
//                                             </table>
//                                             <table style={tableStyle}>
//                                                 <tbody>
//                                                     <tr>
//                                                         <th style={thStyle} colSpan={6}>
//                                                             INVITATION TO BID
//                                                         </th>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle}><strong>BID NUMBER</strong></td>
//                                                         <td style={tdStyle} colSpan={2}><strong>CLOSING DATE</strong></td>
//                                                         <td style={tdStyle} colSpan={2}><strong>DESCRIPTION</strong></td>
//                                                         <td style={tdStyle}><strong>LOCATION OF THE SAMSA HEAD OFFICE</strong></td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle}>SAMSA/100/2024/25</td>
//                                                         <td style={tdStyle} colSpan={2}>
//                                                             18/11/2024<br />11H00 a.m.
//                                                         </td>
//                                                         <td style={tdStyle} colSpan={2}>
//                                                             <strong>
//                                                                 THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY: MARITIME SPECIAL PROJECTS WOULD LIKE TO INVITE PROPOSALS FROM SHIP CHANDLERS/ SERVICE PROVIDERS FOR THE SUPPLY OF VICTUALS (PROVISIONS), NEW BED LINEN, NEW CUTLERY, NEW CROCKERY AND OTHER CONSUMABLES TO OUR SIX (6) VESSELS (AFRICANA, ELLEN KHUZWAYO, SARAH BAARTMAN, LILIAN NGOYI, RUTH FIRST AND VICTORIA MXENGE) FOR UP TO 31 OCTOBER 2026 FOR ALL SOUTH AFRICAN PORTS AS AND WHEN REQUIRED.
//                                                             </strong>
//                                                         </td>
//                                                         <td style={tdStyle}>
//                                                             146 Lunnon Road<br />
//                                                             Cnr Jan Shoba & Lunnon Road<br />
//                                                             <strong>HILLCREST</strong><br />
//                                                             PRETORIA<br />0183
//                                                         </td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle} colSpan={3}><strong>Compulsory Site Inspection</strong></td>
//                                                         <td style={tdStyle} colSpan={3}><strong>N/A</strong></td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle} colSpan={3}>Venue</td>
//                                                         <td style={tdStyle} colSpan={3}>

//                                                         </td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle} colSpan={3}>Time</td>
//                                                         <td style={tdStyle} colSpan={3}><strong></strong></td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle} colSpan={6}>
//                                                             For general enquiries, please contact Mr Ivor Mothoane at imothoane@samsa.org.za/ jchilopo@samsa.org.za. Only written enquiries will be responded to.
//                                                         </td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle} colSpan={2}>Ivor Mothoane</td>
//                                                         <td style={tdStyle}>Tel</td>
//                                                         <td style={tdStyle} colSpan={3}>012 366 2600</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle} colSpan={2}></td>
//                                                         <td style={tdStyle}>Email</td>
//                                                         <td style={tdStyle} colSpan={3}>imothoane@samsa.org.za</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle} colSpan={6}>
//                                                             Tender documents can be downloaded on SAMSA website <a href="https://www.samsa.org.za">www.samsa.org.za</a> or on the National Treasury e-Tender portal.<br />
//                                                             <a href="/Tender%20Documents/Bid%20Document%20Printing%20(Operations)%202024.pdf">
//                                                                 📄 Bid Document Printing (Operations) 2024.pdf
//                                                             </a><br />
//                                                             <a href="/Tender%20Documents/2.%20TENDER%20REGISTER.pdf">📄 2. TENDER REGISTER.pdf</a>
//                                                             <ul>
//                                                                 <li>Number of ORIGINAL bid documents for contract signing: TWO</li>
//                                                                 <li>Electronic Copy of the original document in PDF (flash drive): ONE</li>
//                                                             </ul>
//                                                         </td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td style={tdStyle} colSpan={6}>
//                                                             SAMSA reserves the right to amend any date specified above. Any changes will be communicated via SAMSA website or the National Treasury e-Tender portal.<br />
//                                                             SAMSA reserves the right to accept or reject any submission in full or in part, and to suspend this process and reject all proposals or part thereof, at any time prior to the awarding of the contract.
//                                                         </td>
//                                                     </tr>
//                                                 </tbody>
//                                             </table>
//                                         </div>



//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab3"
//                                     aria-expanded="false"
//                                     aria-controls="blackTab3"
//                                 >
//                                     SAMSA-106-2024-25-THE APPOINTMENT OF A SERVICE PROVIDER FOR THE RENEWAL
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTab3"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             >
//                                 <div style={{ padding: "2px" }}>
//                                     {/* First Table */}
//                                     <table style={tableStyle}>
//                                         <tbody>
//                                             <tr>
//                                                 <th style={thStyle} colSpan={1}>
//                                                     NAME OF INSTITUTION
//                                                 </th>
//                                                 <td style={tdStyle}>
//                                                     SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                 </td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                 <td style={tdStyle}>
//                                                     THE APPOINTMENT OF A SERVICE PROVIDER FOR THE RENEWAL OF CROWDSTRIKE NGVA LICENCES INCLUDING SUPPORT SERVICES FOR THREE (3) YEARS.
//                                                 </td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>CONTRACT NUMBER</th>
//                                                 <td style={tdStyle}>​SAMSA/106/2024/25 ​</td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>CONTRACT PERIOD</th>
//                                                 <td style={tdStyle}>THREE YEARS ​</td>
//                                             </tr>
//                                             <tr>
//                                                 <th style={thStyle}>DATE OF AWARD</th>
//                                                 <td style={tdStyle}>10/06/2025   </td>
//                                             </tr>
//                                         </tbody>
//                                     </table>

//                                     <br />

//                                     {/* Second Table */}
//                                     <table style={tableStyle}>
//                                         <thead>
//                                             <tr>
//                                                 <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                 <th style={thStyle}>BBBEE LEVEL</th>
//                                                 <th style={thStyle}>NAME OF DIRECTOR</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             <tr>
//                                                 <td style={tdStyle}>Performanta South Africa (Pty) Ltd</td>
//                                                 <td style={tdStyle}>BBBEE Level 1</td>
//                                                 <td style={tdStyle}>Timothy John Collins<br />Kumarie Reddy<br />Brendan Richard Kotze</td>
//                                             </tr>

//                                         </tbody>
//                                     </table>

//                                 </div>

//                             </div>
//                         </div>

//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab4"
//                                     aria-expanded="false"
//                                     aria-controls="blackTab4"
//                                 >
//                                     BID NO: SAMSA/104/2024/25: FOR THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTab4"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             >
//                                 <div className="accordion-body">
//                                     <div style={{ padding: "2px" }}>
//                                         {/* First Table */}
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={1}>
//                                                         NAME OF INSTITUTION
//                                                     </th>
//                                                     <td style={tdStyle}>
//                                                         SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                     <td style={tdStyle}>
//                                                         THE APPOINTMENT OF A SUITABLE AND QUALIFIED SERVICE PROVIDER FOR THE HEATING, VENTILATION AND AIR-CONDITIONING (HVAC) FITOUT PROJECT AT THE SAMSA DURBAN OFFICE
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT NUMBER</th>
//                                                     <td style={tdStyle}>SAMSA/104/2024/25 ​</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT PERIOD</th>
//                                                     <td style={tdStyle}>TEN (10) WEEKS ​</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>DATE OF AWARD</th>
//                                                     <td style={tdStyle}>30/04/2025  </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>

//                                         <br />

//                                         {/* Second Table */}
//                                         <table style={tableStyle}>
//                                             <thead>
//                                                 <tr>
//                                                     <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                     <th style={thStyle}>BBBEE LEVEL</th>
//                                                     <th style={thStyle}>NAME OF DIRECTOR</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr>
//                                                     <td style={tdStyle}>AMAKHAZA MOIA (PTY) Ltd</td>
//                                                     <td style={tdStyle}>BBBEE Level 1</td>
//                                                     <td style={tdStyle}>ELIAS VASILAKI MECHANICOS<br />NAVENDREE GOVENDER</td>
//                                                 </tr>
//                                                 <tr style={rowEven}>
//                                                     <td style={tdStyle}>CONTRACT AMOUNT</td>
//                                                     <td style={tdStyle}>R 2 624 000.00</td>
//                                                     <td style={tdStyle}></td>
//                                                 </tr>

//                                             </tbody>
//                                         </table>
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={6}>
//                                                         INVITATION TO BID
//                                                     </th>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}><strong>BID NUMBER</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>CLOSING DATE</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>DESCRIPTION</strong></td>
//                                                     <td style={tdStyle}><strong>LOCATION OF THE SAMSA HEAD OFFICE</strong></td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}>SAMSA/104/2024/25</td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         31 January 2025<br />11H00 a.m.
//                                                     </td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         <strong>
//                                                             BID NO: SAMSA/104/2024/25: FOR THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) WOULD LIKE TO INVITE PROPOSAL FROM SUITABLE QUALIFIED SERVICE PROVIDERS FOR THE HEATING, VENTILATION AND AIR -CONDITIONING (HVAC) FITOUT PROJECT AT SAMSA DURBAN OFFICE
//                                                         </strong>
//                                                     </td>
//                                                     <td style={tdStyle}>
//                                                         146 Lunnon Road<br />
//                                                         Cnr Jan Shoba & Lunnon Road<br />
//                                                         <strong>HILLCREST</strong><br />
//                                                         PRETORIA<br />0183
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} ><strong>Compulsory Site Briefing</strong></td>
//                                                     <td style={tdStyle} colSpan={2} ><strong>17 January 2025</strong></td>
//                                                     <td style={tdStyle} colSpan={3}><strong>Failure to attend the site briefing meeting is an automatic disqualification. ​</strong></td>

//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={3}>Venue</td>
//                                                     <td style={tdStyle} colSpan={3}>
//                                                         SAMORA MACHEL STREET, DURBAN ON THE 5TH AND 6TH FLOOR
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={3}>Time</td>
//                                                     <td style={tdStyle} colSpan={3}><strong>10:00 AM ​</strong></td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         For general enquiries, please contact Mr Ivor Mothoane at imothoane@samsa.org.za Only written enquiries will be responded to.
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}>Ivor Mothoane</td>
//                                                     <td style={tdStyle}>Tel</td>
//                                                     <td style={tdStyle} colSpan={3}>012 366 2600</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}></td>
//                                                     <td style={tdStyle}>Email</td>
//                                                     <td style={tdStyle} colSpan={3}>imothoane@samsa.org.za</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         Tender documents can be downloaded on SAMSA website <a href="https://www.samsa.org.za">www.samsa.org.za</a> or on the National Treasury e-Tender portal.<br />
//                                                         Technical and financial proposal should be submitted in two (2) separate envelopes. The submission should be as follows:<br />
//                                                         <a href="/Tender%20Documents/Bid%20Document%20Printing%20(Operations)%202024.pdf">
//                                                             📄 Bid Document Printing (Operations) 2024.pdf
//                                                         </a><br />
//                                                         <a href="/Tender%20Documents/2.%20TENDER%20REGISTER.pdf">📄 2. TENDER REGISTER.pdf</a>
//                                                         <ul>
//                                                             <li>Number of ORIGINAL bid documents for contract signing: TWO</li>
//                                                             <li>Electronic Copy of the original document in PDF (flash drive): ONE</li>
//                                                         </ul>
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         SAMSA reserves the right to amend any date specified above. Any changes will be communicated via SAMSA website or the National Treasury e-Tender portal.<br />
//                                                         SAMSA reserves the right to accept or reject any submission in full or in part, and to suspend this process and reject all proposals or part thereof, at any time prior to the awarding of the contract.
//                                                     </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>
//                                     </div>



//                                 </div>
//                             </div>
//                         </div>

//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab5"
//                                     aria-expanded="false"
//                                     aria-controls="blackTab5"
//                                 >
//                                     SAMSA095202324-APPOINTMENT OF A PROFESSIONAL FIRM TO PERFORM INTERNAL AUDIT SERVICES
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTab5"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             >
//                                 <div className="accordion-body">
//                                     <div style={{ padding: "2px" }}>
//                                         {/* First Table */}
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={1}>
//                                                         NAME OF INSTITUTION
//                                                     </th>
//                                                     <td style={tdStyle}>
//                                                         SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                     <td style={tdStyle}>
//                                                         APPOINTMENT OF A PROFESSIONAL FIRM TO PERFORM INTERNAL AUDIT SERVICES FOR THE
//                                                         SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) FOR A PERIOD OF THREE (3) YEARS
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT NUMBER</th>
//                                                     <td style={tdStyle}>SAMSA/095/2023/24 </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT PERIOD</th>
//                                                     <td style={tdStyle}>Three (3) years</td>
//                                                 </tr>

//                                                 <tr>
//                                                     <th style={thStyle}>DATE OF AWARD</th>
//                                                     <td style={tdStyle}>14/02/2025</td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>

//                                         <br />

//                                         {/* Second Table */}
//                                         <table style={tableStyle}>
//                                             <thead>
//                                                 <tr>
//                                                     <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                     <th style={thStyle}>BBBEE LEVEL</th>
//                                                     <th style={thStyle}>NAME OF DIRECTOR</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr>
//                                                     <td style={tdStyle}>NEXIA SAB & T </td>
//                                                     <td style={tdStyle}>BBBEE Level 1</td>
//                                                     <td style={tdStyle}>
//                                                     </td>
//                                                 </tr>
//                                                 <tr style={rowEven}>
//                                                     <td style={tdStyle}>CONTRACT AMOUNT</td>
//                                                     <td style={tdStyle}>​R 5 200 000.00</td>
//                                                     <td style={tdStyle}></td>
//                                                 </tr>

//                                             </tbody>
//                                         </table>
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={6}>
//                                                         INVITATION TO BID
//                                                     </th>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}><strong>BID NUMBER</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>CLOSING DATE</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>DESCRIPTION</strong></td>
//                                                     <td style={tdStyle}><strong>LOCATION OF THE SAMSA HEAD OFFICE</strong></td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}>SAMSA/095/2023/24</td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         16/04/2024<br />11H00 a.m.
//                                                     </td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         <strong> APPOINTMENT OF A PROFESSIONAL FIRM TO PERFORM INTERNAL AUDIT SERVICES FOR THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) FOR A PERIOD OF THREE (3) YEARS
//                                                         </strong>
//                                                     </td>
//                                                     <td style={tdStyle}>
//                                                         146 Lunnon Road<br />
//                                                         Cnr Jan Shoba & Lunnon Road<br />
//                                                         <strong>HILLCREST</strong><br />
//                                                         PRETORIA<br />0183
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         For general enquiries, please contact Mr Ivor Mothoane at imothoane@samsa.org.za/ jchilopo@samsa.org.za. Only written enquiries will be responded to.
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}>Ivor Mothoane</td>
//                                                     <td style={tdStyle}>Tel</td>
//                                                     <td style={tdStyle} colSpan={3}>012 366 2600</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}></td>
//                                                     <td style={tdStyle}>Email</td>
//                                                     <td style={tdStyle} colSpan={3}>imothoane@samsa.org.za</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         Tender documents can be downloaded on SAMSA website <a href="https://www.samsa.org.za">www.samsa.org.za</a> or on the National Treasury e-Tender portal.<br />
//                                                         <a href="/Tender%20Documents/Bid%20Document%20Printing%20(Operations)%202024.pdf">
//                                                             📄 Bid Document Printing (Operations) 2024.pdf
//                                                         </a><br />
//                                                         <a href="/Tender%20Documents/2.%20TENDER%20REGISTER.pdf">📄 2. TENDER REGISTER.pdf</a>
//                                                         <ul>
//                                                             <li>Number of ORIGINAL bid documents for contract signing: TWO</li>
//                                                             <li>Electronic Copy of the original document in PDF (flash drive): ONE</li>
//                                                         </ul>
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         SAMSA reserves the right to amend any date specified above. Any changes will be communicated via SAMSA website or the National Treasury e-Tender portal.<br />
//                                                         SAMSA reserves the right to accept or reject any submission in full or in part, and to suspend this process and reject all proposals or part thereof, at any time prior to the awarding of the contract.
//                                                     </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>
//                                     </div>

//                                 </div>
//                             </div>
//                         </div>

//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab6"
//                                     aria-expanded="false"
//                                     aria-controls="blackTab6"
//                                 >
//                                     SAMSA/066/2023/24-APPOINTMENT OF A SUITABLE SERVICE PROVIDER TO CARRY-OUT ALL SURVERS
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTab6"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab">

//                                 <div className="accordion-body">
//                                     <div style={{ padding: "2px" }}>
//                                         {/* First Table */}
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={1}>
//                                                         NAME OF INSTITUTION
//                                                     </th>
//                                                     <td style={tdStyle}>
//                                                         SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                     <td style={tdStyle}>
//                                                         APPOINTMENT OF A SUITABLE SERVICE PROVIDER TO CARRY OUT ALL SURVERS AND INSPECTION IN TERMS OF THE MERCHANT SHIPPING ACT OF 1951 FOR ALL VESSELS OWNED AND MANAGED BY SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) FOR PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF ON MLRF
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT NUMBER</th>
//                                                     <td style={tdStyle}>SAMSA/066/2023/24</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT PERIOD <br />Start date</th>
//                                                     <td style={tdStyle}>01/12/2024​</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT PERIOD <br /> End  date</th>
//                                                     <td style={tdStyle}>26/10/2026<br />Not exceeding 26 October 2026 on behalf of MLRF</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>DATE OF AWARD</th>
//                                                     <td style={tdStyle}>30/09/2024</td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>

//                                         <br />

//                                         {/* Second Table */}
//                                         <table style={tableStyle}>
//                                             <thead>
//                                                 <tr>
//                                                     <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                     <th style={thStyle}>BBBEE LEVEL</th>
//                                                     <th style={thStyle}>NAME OF DIRECTOR</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr>
//                                                     <td style={tdStyle}>Bureau Veritas testing and inspection South Africa (Pty) Ltd</td>
//                                                     <td style={tdStyle}>BBBEE Level</td>
//                                                     <td style={tdStyle}>Emilie Marion Anne Gigot<br />Gavin Hefer
//                                                     </td>
//                                                 </tr>
//                                                 <tr style={rowEven}>
//                                                     <td style={tdStyle}>CONTRACT AMOUNT</td>
//                                                     <td style={tdStyle}>R 4 735 945.89</td>
//                                                     <td style={tdStyle}></td>
//                                                 </tr>

//                                             </tbody>
//                                         </table>
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={6}>
//                                                         INVITATION TO BID
//                                                     </th>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}><strong>BID NUMBER</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>CLOSING DATE</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>DESCRIPTION</strong></td>
//                                                     <td style={tdStyle}><strong>LOCATION OF THE SAMSA HEAD OFFICE</strong></td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}>SAMSA/066/2023/24</td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         14 November 2023<br />11H00 a.m.
//                                                     </td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         <strong>
//                                                             APPOINTMENT OF A SUITABLE SERVICE PROVIDER TO CARRY-OUT ALL SURVERS AND INSPECTIONS IN TERMS OF THE MERCHANT SHIPPING ACT OF 1951 FOR ALL VESSELS OWNED AND MANAGED BY SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) MARITIME SPECIAL PROJECTS FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026, ON BEHALF OT THE MLRF.
//                                                         </strong>
//                                                     </td>
//                                                     <td style={tdStyle}>
//                                                         146 Lunnon Road<br />
//                                                         Cnr Jan Shoba & Lunnon Road<br />
//                                                         <strong>HILLCREST</strong><br />
//                                                         PRETORIA<br />0183
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         For general enquiries, please contact Mr Ivor Mothoane at imothoane@samsa.org.za/ jchilopo@samsa.org.za. Only written enquiries will be responded to.
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}>Ivor Mothoane</td>
//                                                     <td style={tdStyle}>Tel</td>
//                                                     <td style={tdStyle} colSpan={3}>012 366 2600</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}></td>
//                                                     <td style={tdStyle}>Email</td>
//                                                     <td style={tdStyle} colSpan={3}>imothoane@samsa.org.za</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         Tender documents can be downloaded on SAMSA website <a href="https://www.samsa.org.za">www.samsa.org.za</a> or on the National Treasury e-Tender portal.<br />
//                                                         <a href="/Tender%20Documents/Bid%20Document%20Printing%20(Operations)%202024.pdf">
//                                                             📄 Bid Document Printing (Operations) 2024.pdf
//                                                         </a><br />
//                                                         <a href="/Tender%20Documents/2.%20TENDER%20REGISTER.pdf">📄 2. TENDER REGISTER.pdf</a>
//                                                         <ul>
//                                                             <li>Number of ORIGINAL bid documents for contract signing: TWO</li>
//                                                             <li>Electronic Copy of the original document in PDF (flash drive): ONE</li>
//                                                         </ul>
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         SAMSA reserves the right to amend any date specified above. Any changes will be communicated via SAMSA website or the National Treasury e-Tender portal.<br />
//                                                         SAMSA reserves the right to accept or reject any submission in full or in part, and to suspend this process and reject all proposals or part thereof, at any time prior to the awarding of the contract.
//                                                     </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab7"
//                                     aria-expanded="false"
//                                     aria-controls="blackTab7"
//                                 >
//                                     SAMSA/067/2023/24-APPOINTMENT OF A SUITABLE SERVICE PROVIDER FOR THE SUPPLY
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTab7"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             >
//                                 <div className="accordion-body">
//                                     <div style={{ padding: "2px" }}>
//                                         {/* First Table */}
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={1}>
//                                                         NAME OF INSTITUTION
//                                                     </th>
//                                                     <td style={tdStyle}>
//                                                         SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                     <td style={tdStyle}>
//                                                         RE-SAMSA/067/2023/24 APPOINTMENT OF SUITABLE SERVICE PROVIDER FOR SUPPLY INSTALLATION & COMMISSIONING OF FOUR (4) THERMAL IMAGING INFRARED CAMERAS ONBOARD FOUR (4) PATROL VESSELS.

//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT NUMBER</th>
//                                                     <td style={tdStyle}>SAMSA/067/2023/24​</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT PERIOD <br />Start date</th>
//                                                     <td style={tdStyle}>06/11/2024 ​</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT PERIOD <br /> End  date</th>
//                                                     <td style={tdStyle}>28 /03/2025</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>DATE OF AWARD</th>
//                                                     <td style={tdStyle}>21/10/2024    </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>

//                                         <br />

//                                         {/* Second Table */}
//                                         <table style={tableStyle}>
//                                             <thead>
//                                                 <tr>
//                                                     <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                     <th style={thStyle}>BBBEE LEVEL</th>
//                                                     <th style={thStyle}>NAME OF DIRECTOR</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr>
//                                                     <td style={tdStyle}>Timeless Technologies (Pty) Ltd</td>
//                                                     <td style={tdStyle}>BBBEE Level 2</td>
//                                                     <td style={tdStyle}>Marthinus Diedericks</td>
//                                                 </tr>
//                                                 <tr style={rowEven}>
//                                                     <td style={tdStyle}>CONTRACT AMOUNT</td>
//                                                     <td style={tdStyle}>R 8 357 201 .78</td>
//                                                     <td style={tdStyle}></td>
//                                                 </tr>

//                                             </tbody>
//                                         </table>
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={6}>
//                                                         INVITATION TO BID
//                                                     </th>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}><strong>BID NUMBER</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>CLOSING DATE</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>DESCRIPTION</strong></td>
//                                                     <td style={tdStyle}><strong>LOCATION OF THE SAMSA HEAD OFFICE</strong></td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}>SAMSA/067/2023/24</td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         14 November 2023<br />11H00 a.m.
//                                                     </td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         <strong>
//                                                             APPOINTMENT OF A SUITABLE SERVICE PROVIDER FOR THE SUPPLY, INSTALLATION AND COMMISSIONING OF FOUR (4) THERMAL IMAGING INFRARED CAMERAS ON BOARD FOUR (4) PATROL VESSELS
//                                                         </strong>
//                                                     </td>
//                                                     <td style={tdStyle}>
//                                                         146 Lunnon Road<br />
//                                                         Cnr Jan Shoba & Lunnon Road<br />
//                                                         <strong>HILLCREST</strong><br />
//                                                         PRETORIA<br />0183
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         For general enquiries, please contact Mr Ivor Mothoane at imothoane@samsa.org.za/ jchilopo@samsa.org.za. Only written enquiries will be responded to.
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}>Ivor Mothoane</td>
//                                                     <td style={tdStyle}>Tel</td>
//                                                     <td style={tdStyle} colSpan={3}>012 366 2600</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}></td>
//                                                     <td style={tdStyle}>Email</td>
//                                                     <td style={tdStyle} colSpan={3}>imothoane@samsa.org.za</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         Tender documents can be downloaded on SAMSA website <a href="https://www.samsa.org.za">www.samsa.org.za</a> or on the National Treasury e-Tender portal.<br />
//                                                         <a href="/Tender%20Documents/Bid%20Document%20Printing%20(Operations)%202024.pdf">
//                                                             📄 Bid Document Printing (Operations) 2024.pdf
//                                                         </a><br />
//                                                         <a href="/Tender%20Documents/2.%20TENDER%20REGISTER.pdf">📄 2. TENDER REGISTER.pdf</a>
//                                                         <ul>
//                                                             <li>Number of ORIGINAL bid documents for contract signing: TWO</li>
//                                                             <li>Electronic Copy of the original document in PDF (flash drive): ONE</li>
//                                                         </ul>
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         SAMSA reserves the right to amend any date specified above. Any changes will be communicated via SAMSA website or the National Treasury e-Tender portal.<br />
//                                                         SAMSA reserves the right to accept or reject any submission in full or in part, and to suspend this process and reject all proposals or part thereof, at any time prior to the awarding of the contract.
//                                                     </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>
//                                     </div>

//                                 </div>
//                             </div>
//                         </div>

//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab8"
//                                     aria-expanded="false"
//                                     aria-controls="blackTab8"
//                                 >
//                                     APPOINTMENT OF TRAVEL MANAGEMENT COMPANY TO PROVIDE TRAVEL SERVICES
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTab8"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             > <div className="accordion-body">
//                                     <div style={{ padding: "2px" }}>
//                                         {/* First Table */}
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={1}>
//                                                         NAME OF INSTITUTION
//                                                     </th>
//                                                     <td style={tdStyle}>
//                                                         SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                     <td style={tdStyle}>
//                                                         APPOINTMENT OF TRAVEL MANAGEMENT COMPANEY TO PROVIDE TRAVEL SERVICES FOR SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) FOR A PERIOD OF THREE (3) YEARS SUBJECTED TO TWO (2) YEARS EXTENSION, BASED ON PERFORMANCE
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT NUMBER</th>
//                                                     <td style={tdStyle}>SAMSA/096/2023/24​ ​ ​</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT PERIOD<br />Start date </th>
//                                                     <td style={tdStyle}>01/10/2024 </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT PERIOD<br /> End  date </th>
//                                                     <td style={tdStyle}>31/09/2027<br />Subjected two years extension, bases on performance </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>DATE OF AWARD</th>
//                                                     <td style={tdStyle}>​​​18/01/2024</td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>

//                                         <br />

//                                         {/* Second Table */}
//                                         <table style={tableStyle}>
//                                             <thead>
//                                                 <tr>
//                                                     <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                     <th style={thStyle}>BBBEE LEVEL</th>
//                                                     <th style={thStyle}>NAME OF DIRECTOR</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr>
//                                                     <td style={tdStyle}>Atlantis Corporate Travel (Pty) Ltd</td>
//                                                     <td style={tdStyle}>BBBEE Level 2</td>
//                                                     <td style={tdStyle}>Androula Michel<br />
//                                                         Marios Andreou<br />
//                                                         Sithembiso Prinse Ntshalintshali<br />
//                                                         Archie Letlhogonolo Modiba
//                                                     </td>
//                                                 </tr>
//                                                 <tr style={rowEven}>
//                                                     <td style={tdStyle}>​Contract Amount</td>
//                                                     <td style={tdStyle}>As and when (based on transaction and budget managed by SAMSA)</td>
//                                                     <td style={tdStyle}></td>
//                                                 </tr>

//                                             </tbody>
//                                         </table>
//                                     </div>

//                                 </div>
//                             </div>
//                         </div>
//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab9"
//                                     aria-expanded="false"
//                                     aria-controls="blackTab9"
//                                 >
//                                     South African Maritime Safety Authority invite interested bidders to procure S.A Vessel
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTab9"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             > <div className="accordion-body">
//                                     <div style={{ padding: "2px" }}>
//                                         {/* First Table */}
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={1}>
//                                                         NAME OF INSTITUTION
//                                                     </th>
//                                                     <td style={tdStyle}>
//                                                         SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                     <td style={tdStyle}>
//                                                         South African Maritime Safety Authority invite interested bidders to procure S.A Agulhas Vessel
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT NUMBER</th>
//                                                     <td style={tdStyle}>SAMSA/060/2023/24</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT PERIOD</th>
//                                                     <td style={tdStyle}> </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>DATE OF AWARD</th>
//                                                     <td style={tdStyle}>18/01/2024 </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>

//                                         <br />

//                                         {/* Second Table */}
//                                         <table style={tableStyle}>
//                                             <thead>
//                                                 <tr>
//                                                     <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>
//                                                     <th style={thStyle}>BBBEE LEVEL</th>
//                                                     <th style={thStyle}>NAME OF DIRECTOR</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr>
//                                                     <td style={tdStyle}>The meihuizen J*S Maritime joint Venture</td>
//                                                     <td style={tdStyle}>BBBEE Level 1</td>
//                                                     <td style={tdStyle}>Stefan Bulow </td>
//                                                 </tr>
//                                                 <tr style={rowEven}>
//                                                     <td style={tdStyle}>CONTRACT AMOUNT</td>
//                                                     <td style={tdStyle}>R 45 000 000.00</td>
//                                                     <td style={tdStyle}></td>
//                                                 </tr>

//                                             </tbody>
//                                         </table>
//                                     </div>


//                                 </div>
//                             </div>
//                         </div>

//                         <div className="accordion-item">
//                             <h2 className="accordion-header">
//                                 <button
//                                     className="accordion-button collapsed"
//                                     type="button"
//                                     data-bs-toggle="collapse"
//                                     data-bs-target="#blackTab10"
//                                     aria-expanded="false"
//                                     aria-controls="blackTab10"
//                                 >
//                                     Appointment of a panel of three (3) service providers (suppliers) to provide SAMSA Maritime
//                                 </button>
//                             </h2>
//                             <div
//                                 id="blackTab10"
//                                 className="accordion-collapse collapse"
//                                 data-bs-parent="#blackTab"
//                             >
//                                 <div className="accordion-body">
//                                     <div style={{ padding: "2px" }}>
//                                         {/* First Table */}
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={1}>
//                                                         NAME OF INSTITUTION
//                                                     </th>
//                                                     <td style={tdStyle}>
//                                                         SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT DESCRIPTION</th>
//                                                     <td style={tdStyle}>
//                                                         APPOINTMENT OF A PANEL OF THREE (3) SERVICE PROVIDERS (SUPPIER) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH MARINE ENGINEERING SERVICE FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF.

//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <th style={thStyle}>CONTRACT NUMBER</th>
//                                                     <td style={tdStyle}>SAMSA /057/2022/23​</td>
//                                                 </tr>

//                                                 <tr>
//                                                     <th style={thStyle}>DATE OF AWARD</th>
//                                                     <td style={tdStyle}>31/05/23</td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>

//                                         <br />

//                                         {/* Second Table */}
//                                         <table style={tableStyle}>
//                                             <thead>
//                                                 <tr>
//                                                     <th style={thStyle}>NAME OF SUCCESSFUL BIDDER</th>

//                                                     <th style={thStyle}>NAME OF DIRECTOR</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr>
//                                                     <td style={tdStyle}></td>
//                                                     <td style={tdStyle}>Nkosi Phendule Projects<br />Hesper Engineering<br />Dormac Marine & Engineering​​ </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}>Period Cover</td>
//                                                     <td style={tdStyle}>Three (3) Years</td>
//                                                 </tr>


//                                             </tbody>
//                                         </table>
//                                         <table style={tableStyle}>
//                                             <tbody>
//                                                 <tr>
//                                                     <th style={thStyle} colSpan={6}>
//                                                         INVITATION TO BID
//                                                     </th>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}><strong>BID NUMBER</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>CLOSING DATE</strong></td>
//                                                     <td style={tdStyle} colSpan={2}><strong>DESCRIPTION</strong></td>
//                                                     <td style={tdStyle}><strong>LOCATION OF THE SAMSA HEAD OFFICE</strong></td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle}>SAMSA/057/2022/23</td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         14​ December 2022<br />11H00 a.m.
//                                                     </td>
//                                                     <td style={tdStyle} colSpan={2}>
//                                                         <strong>
//                                                             Appointment of a panel of three (3) service providers (suppliers) to provide SAMSA Maritime Special Projects with Maritime Engineering services for a period not exceeding 26 October 2026 on behalf of the MLRF
//                                                         </strong>
//                                                     </td>
//                                                     <td style={tdStyle}>
//                                                         146 Lunnon Road<br />
//                                                         Cnr Jan Shoba & Lunnon Road<br />
//                                                         <strong>HILLCREST</strong><br />
//                                                         PRETORIA<br />0183
//                                                     </td>
//                                                 </tr>

//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         For general enquiries, please contact Mr Ivor Mothoane at imothoane@samsa.org.za Only written enquiries will be responded to.
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}>Ivor Mothoane</td>
//                                                     <td style={tdStyle}>Tel</td>
//                                                     <td style={tdStyle} colSpan={3}>012 366 2600</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={2}></td>
//                                                     <td style={tdStyle}>Email</td>
//                                                     <td style={tdStyle} colSpan={3}>imothoane@samsa.org.za</td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         Tender documents can be downloaded on SAMSA website <a href="https://www.samsa.org.za">www.samsa.org.za</a> or on the National Treasury e-Tender portal.<br />
//                                                         Technical and financial proposal should be submitted in two (2) separate envelopes. The submission should be as follows:<br />
//                                                         <a href="/Tender%20Documents/Bid%20Document%20Printing%20(Operations)%202024.pdf">
//                                                             📄 Bid Document Printing (Operations) 2024.pdf
//                                                         </a><br />
//                                                         <a href="/Tender%20Documents/2.%20TENDER%20REGISTER.pdf">📄 2. TENDER REGISTER.pdf</a>

//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td style={tdStyle} colSpan={6}>
//                                                         The South African Maritime Safety Authority is not obliged to appoint the lowest tender and further reserves the right to return late tender submissions unopened and cancel/ alter any bid herein advertised entirely or in part.
//                                                     </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>
//                                     </div>


//                                 </div>
//                             </div>
//                         </div>















//                     </div>
//                 </div>









//                 <div className="col-12">
//                     {loading ? (
//                         <div>Loading Tenders...</div>
//                     ) : (
//                         <ul className="strip-ul mt-3">
//                             {Object.entries(groupedDocs).map(([folderName, docs], index) => (
//                                 <li className="bg-transparent p-0" key={index}>
//                                     <div className="row g-4">
//                                         {/* <div className="col-auto">
//                       <img src={pdfIcon} alt="PDF icon" />
//                     </div> */}
//                                         <div className="col">
//                                             <div className="row g-4">
//                                                 <div className="col-md">
//                                                     {/* <div className="font-18 font-600">Tenders Name</div> */}
//                                                     <div className="font-16 font-400">
//                                                         {/* <p className="text-orange-ef3e33 text-uppercase">{folderName}</p> */}
//                                                         {/* <ul className="list">
//                               {docs.map((item, i) => (
//                                 <li key={i}>
//                                   <a
//                                     href={`${WebApiURL}File/view/${encodeURIComponent(item.fileId)}`}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                   >
//                                     {item.fileName}
//                                   </a>
//                                 </li>
//                               ))}
//                             </ul> */}
//                                                     </div>
//                                                 </div>
//                                                 {/* <div className="col-md-auto">
//                           <div className="font-18 font-600">Tender Opening Date</div>
//                           <div className="font-16 font-400">
//                             {docs[0]?.modifiedDate ? new Date(docs[0].modifiedDate).toLocaleString() : '—'}
//                           </div>
//                         </div>
//                          <div className="col-md-auto">
//                           <div className="font-18 font-600">Tender Closing Date</div>
//                           <div className="font-16 font-400">
//                             {docs[0]?.modifiedDate ? new Date(docs[0].modifiedDate).toLocaleString() : '—'}
//                           </div>
//                         </div> */}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </li>
//                             ))}
//                         </ul>
//                     )}
//                 </div>
//             </div>
//         </>
//     );
// }




// export default AwardedTenders;


//New Code With API DATA

// import React, { useEffect, useState } from "react";
// import { useFileContext } from "./../../Contexts/FileContext";
// import { WebApiURL } from "./../../Constants/Constants";

// function AwardedTenders() {
//     const { setComponentName, setSection } = useFileContext();
//     const [tenders, setTenders] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         setComponentName("ALL FORMS");
//         setSection("");

//         // ✅ Fetch tenders from backend API
//         const fetchTenders = async () => {
//             try {
//                 const response = await fetch(`${WebApiURL}Tender/all`);
//                 const data = await response.json();

//                 console.log("Data returned from backend", data);

//                 // ✅ Only keep Awarded Tenders
//                 const awarded = (data || []).filter(
//                     (t) => t.component === "Awarded Tenders"
//                 );

//                 setTenders(awarded || []);
//             } catch (error) {
//                 console.error("Error fetching tenders:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchTenders();
//     }, [setComponentName, setSection]);

//     const tableStyle = {
//         width: "100%",
//         borderCollapse: "collapse",
//         fontFamily: "Arial, sans-serif",
//     };

//     const thStyle = {
//         backgroundColor: "#008B8B", // Teal header
//         color: "white",
//         padding: "10px",
//         textAlign: "left",
//         fontWeight: "bold",
//         border: "1px solid #ccc",
//     };

//     const tdStyle = {
//         padding: "10px",
//         border: "1px solid #ccc",
//     };

//     const rowEven = { backgroundColor: "#F9F9F9" };

//     return (
//         <>
//             <div className="service-title font-700 mb-3 text-uppercase">
//                 Awarded
//                 <span className="text-orange-ef3e33 font-400"> Tenders </span>
//             </div>

//             {loading ? (
//                 <div>Loading Tenders...</div>
//             ) : (
//                 <div className="row g-3 g-sm-4 g-md-4">
//                     <div className="col-12">
//                         <div className="accordion blackTab" id="blackTab">
//                             {tenders.map((tender, index) => (
//                                 <div className="accordion-item" key={index}>
//                                     {/* <h2 className="accordion-header">
//                                         <button
//                                             className="accordion-button collapsed"
//                                             type="button"
//                                             data-bs-toggle="collapse"
//                                             data-bs-target={`#tender-${index}`}
//                                             aria-expanded="false"
//                                             aria-controls={`tender-${index}`}
//                                         >
//                                              {tender.section }
//                                         </button>
//                                     </h2> */}
//                                     <h2 className="accordion-header">
//                                         <button
//                                             className="accordion-button collapsed"
//                                             type="button"
//                                             data-bs-toggle="collapse"
//                                             data-bs-target={`#tender-${index}`}
//                                             aria-expanded="false"
//                                             aria-controls={`tender-${index}`}
//                                         >
//                                             <div className="row w-100 m-0">
//                                                 {/* Section Name */}
//                                                 <div className="col-12 col-md-6 fw-semibold">
//                                                     <span>{tender.section}</span>
//                                                 </div>

//                                                 {/* Open Date */}
//                                                 <div className="col-12 col-md-2 text-md">
//                                                     <span className="d-none d-md-inline fw-semibold">Open Date: </span><br />
//                                                     <span>
//                                                         {tender.openDate && !isNaN(new Date(tender.openDate))
//                                                             ? new Date(tender.openDate).toLocaleDateString("en-GB")
//                                                             : ""}
//                                                     </span>
//                                                 </div>

//                                                 {/* Closing Date & Time */}
//                                                 <div className="col-12 col-md-3 text-md">
//                                                     <span className="d-none d-md-inline fw-semibold">Close Date & Time: </span><br />
//                                                     <span>
//                                                         {tender.closingDate && !isNaN(new Date(tender.closingDate))
//                                                             ? new Date(tender.closingDate).toLocaleString("en-GB", {
//                                                                 day: "2-digit",
//                                                                 month: "2-digit",
//                                                                 year: "numeric",
//                                                                 hour: "2-digit",
//                                                                 minute: "2-digit"
//                                                             })
//                                                             : ""}
//                                                     </span>
//                                                 </div>

//                                                 {/* Status */}
//                                                 <div className="col-12 col-md-1 text-md-end">
//                                                     <span className="d-none d-md-inline fw-semibold">Status: </span><br />
//                                                     <span>{tender.status || ""}</span>
//                                                 </div>
//                                             </div>
//                                         </button>
//                                     </h2>
//                                     <div
//                                         id={`tender-${index}`}
//                                         className="accordion-collapse collapse"
//                                         data-bs-parent="#blackTab"
//                                     >
//                                         <div style={{ padding: "2px" }}>



//                                             <div dangerouslySetInnerHTML={{ __html: tender.fileHTMLContent }} />



//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// }

// export default AwardedTenders;


//New Code With Print and search
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useFileContext } from "./../../Contexts/FileContext";
import { WebApiURL } from "./../../Constants/Constants";

function AwardedTenders() {
  const { setComponentName, setSection } = useFileContext();
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const printRef = useRef(null);

  useEffect(() => {
    setComponentName("ALL FORMS");
    setSection("");

    const fetchTenders = async () => {
      try {
        const response = await fetch(`${WebApiURL}Tender/all`);
        const data = await response.json();

        // ✅ Only keep Awarded Tenders
        const awarded = (data || []).filter(
          (t) => t.component === "Awarded Tenders"
        );

        setTenders(awarded || []);
      } catch (error) {
        console.error("Error fetching tenders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTenders();
  }, [setComponentName, setSection]);

  // 🔍 Filter tenders by section, status, open date, closing date
  const filteredTenders = useMemo(() => {
    if (!searchTerm) return tenders;
    const term = searchTerm.toLowerCase();

    return tenders.filter((t) => {
      const section = (t.section || "").toString().toLowerCase();
      const status = (t.status || "").toString().toLowerCase();

      const openDateStr =
        t.openDate && !isNaN(new Date(t.openDate))
          ? new Date(t.openDate)
              .toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
              .toLowerCase()
          : "";

      const closingDateStr =
        t.closingDate && !isNaN(new Date(t.closingDate))
          ? new Date(t.closingDate)
              .toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
              .toLowerCase()
          : "";

      return (
        section.includes(term) ||
        status.includes(term) ||
        openDateStr.includes(term) ||
        closingDateStr.includes(term)
      );
    });
  }, [searchTerm, tenders]);

  // 🖨️ Print handler
  const handlePrint = () => {
    if (!printRef.current) return;
    const printContent = printRef.current.innerHTML;
    const newWindow = window.open("", "", "width=1200,height=650");
    newWindow.document.write(`
      <html>
        <head>
          <title>Print Preview - Awarded Tenders</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .accordion-button { background: #f8f9fa; font-weight: bold; }
            .accordion-item { border: 1px solid #ddd; margin-bottom: 10px; border-radius: 6px; }
            .accordion-body { padding: 10px 20px; }
            .tender-header { display: none !important; }
            .accordion-button { display: block; text-align: left; width: 100%; }
          </style>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };

  return (
    <>
      {/* Header and Search/Print Controls */}
      <div className="service-title font-700 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
        <div>
          Awarded <span className="text-orange-ef3e33 font-400">Tenders</span>
        </div>

        <div className="d-flex flex-wrap gap-2">
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ width: "260px" }}
            placeholder="Search by section, status, or date..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className="about-btn btn-green-38B652 text-decoration-none"
            onClick={handlePrint}
          >
            Print
          </button>
        </div>
      </div>

      {/* Body */}
      {loading ? (
        <div>Loading Tenders...</div>
      ) : filteredTenders.length === 0 ? (
        <div>No matching tenders found.</div>
      ) : (
        <div className="row g-3 g-sm-4 g-md-4" ref={printRef}>
          <div className="col-12">
            <div className="accordion blackTab" id="blackTab">
              {filteredTenders.map((tender, index) => (
                <div className="accordion-item" key={index}>
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#tender-${index}`}
                      aria-expanded="false"
                      aria-controls={`tender-${index}`}
                    >
                      <div className="row w-100 m-0">
                        {/* Section */}
                        <div className="col-12 col-md-6 fw-semibold">
                          
                          <span>{tender.bidNumber}</span><br />
                          <span>{tender.section}</span>
                        </div>

                        {/* Open Date */}
                        <div className="col-12 col-md-2 text-md">
                          <span className="d-none d-md-inline fw-semibold">
                            Open Date:
                          </span>
                          <br />
                          <span>
                            {tender.openDate &&
                            !isNaN(new Date(tender.openDate))
                              ? new Date(
                                  tender.openDate
                                ).toLocaleDateString("en-GB")
                              : ""}
                          </span>
                        </div>

                        {/* Close Date */}
                        <div className="col-12 col-md-3 text-md">
                          <span className="d-none d-md-inline fw-semibold">
                            Close Date & Time:
                          </span>
                          <br />
                          <span>
                            {tender.closingDate &&
                            !isNaN(new Date(tender.closingDate))
                              ? new Date(
                                  tender.closingDate
                                ).toLocaleString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : ""}
                          </span>
                        </div>

                        {/* Status */}
                        <div className="col-12 col-md-1 text-md-end">
                          <span className="d-none d-md-inline fw-semibold">
                            Status:
                          </span>
                          <br />
                          <span>{tender.status || ""}</span>
                        </div>
                      </div>
                    </button>
                  </h2>

                  <div
                    id={`tender-${index}`}
                    className="accordion-collapse collapse"
                    data-bs-parent="#blackTab"
                  >
                    <div style={{ padding: "8px" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: tender.fileHTMLContent,
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AwardedTenders;
